/**
 * Created by danilaeremin on 27.10.15.
 */

/**
* @class pmui.Text Label with default font.
* @extends ccui.Text
* @constructor
* @param {String} text Label text.
* @param {Number} [fontSize] Size of font for label.
*/
pmui.Text = ccui.Text.extend(/** @lends pmui.Text */{
	ctor: function(text, fontSize)
	{
		if (fontSize === undefined)
			fontSize = pm.settings.fontSize;

		this._super(text, pm.settings.fontName, fontSize);
	}
});
